import { render } from "./IndividualsPanel.vue?vue&type=template&id=642e184c&scoped=true"
import script from "./IndividualsPanel.vue?vue&type=script&lang=js"
export * from "./IndividualsPanel.vue?vue&type=script&lang=js"

import "./IndividualsPanel.vue?vue&type=style&index=0&id=642e184c&lang=scss&scoped=true"
import "./IndividualsPanel.vue?vue&type=style&index=1&id=642e184c&lang=scss"
script.render = render
script.__scopeId = "data-v-642e184c"

export default script